import { Component, HostListener, OnInit } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";

@Component({
  selector: "app-brand-reviews",
  templateUrl: "./brand-reviews.component.html",
  styleUrls: ["./brand-reviews.component.scss"]
})
export class BrandReviewsComponent implements OnInit {
  reviews: any[] = [
    {
      title: "Seda Güler | Hummel | E-Ticaret Performans Pazarlama Yöneticisi",
      image: "SedaGuler.jpeg",
      content:
        "Bilgesin.com ile yürüttüğümüz süreç, karşılıklı güvene dayalı ve verimli bir iş birliği oldu. Paylaşılan içgörüler, markamızın stratejik gelişimine değerli katkılar sağladı. (23.12.2025)"
    },
    {
      title: "Fatih Güzey | Peynirci Baba | Pazarlama Müdürü",
      image: "FatihGuzey.jpeg",
      content:
        "Bilgesin.com ile çok verimli bir iş birliğimiz oldu. Hem üretici hem de gıda perakendecisi kimliğimizle, ürünlerimizin araştırılması süreçlerinde büyük fayda sağladık. Özellikle operasyonel yük ve ekstra maliyet oluşturmadan, tüm süreçleri online olarak hızlıca çözebilmek bizim için harika bir deneyimdi. (10.06.2025)"
    },
    {
      title: "Murat Akkuş | Kozza Home | Genel Müdür",
      image: "Murat.jpg",
      content:
        "Bilgesin.com ile gerçekleştirdiğimiz araştırma çalışması, markamızın gelişimine kısa vadede önemli katkılar sağladı. Yeni müşteri kazanımı elde ederken mevcut müşterilerimizi de daha yakından tanıma imkânı bulduk. Araştırma sonucunda paylaşılan rapor doğrultusunda pazarlama ve büyüme yaklaşımımızda kritik güncellemeler yaptık. (03.05.2025)"
    },
    {
      title: "Onur Yılmaz | Someka | Kurucu",
      image: "Onur.jpg",
      content:
        "Bilgesin.com ile yaptığımız çalışma bizim için oldukça değerli bir içgörü kaynağı oldu. Excel tabanlı iş çözümleri sunduğumuz için hedef kitlemiz oldukça spesifik ve bu kitleye ulaşmak ya da ihtiyaçlarını doğru anlamak her zaman kolay olmuyor. Araştırma süreci sayesinde müşterilerimizin ürünlerimizi hangi amaçlarla kullandığını, satın alma kararını etkileyen faktörleri ve hangi segmentlere daha fazla odaklanmamız gerektiğini çok daha net gördük. Bu içgörüler doğrultusunda pazarlama mesajlarımızı ve hedefleme stratejimizi güncelledik. (05.03.2026)"
    }
  ];

  sliderOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    dotsEach: 1,
    navSpeed: 700,
    autoplay: true,
    margin: 15,
    responsive: {
      0: {
        items: 1
      },
      680: {
        items: 2
      },
      940: {
        items: 3
      }
    },
    nav: false
  };

  private resizeTimeout: any;

  @HostListener("window:resize")
  onResize(): void {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.sliderOptions = { ...this.sliderOptions };
    }, 200);
  }

  constructor() {}

  ngOnInit(): void {}
}
